const EditionBase = 'base';
const Edition299 = '299';
const Edition150 = '150';
const Edition99 = '99';
const Edition75 = '75';
const Edition50 = '50';
const Edition25 = '25';
const Edition10 = '10';
const Edition5 = '5';
const Edition1 = '1';

export const WaxChromeEdition = {
    [EditionBase]: { intensity: 0 },
    [Edition299]: { intensity: 0 },
    [Edition150]: { intensity: 0.1 },
    [Edition99]: { intensity: 0.2 },
    [Edition75]: { intensity: 0.3 },
    [Edition50]: { intensity: 0.4 },
    [Edition25]: { intensity: 0.6 },
    [Edition10]: { intensity: 0.8, pulse: true },
    [Edition5]: { intensity: 1, pulse: true },
    [Edition1]: { intensity: 1, pulse: true },
};

export const WaxChromeWhite = {
    id: 'wax-chrome-white',
    name: 'White Refractor',
    color: '#ffffff',
};

export const WaxChromeBlue = {
    id: 'wax-chrome-blue',
    name: 'Blue Refractor',
    color: '#00BFFF', // #7dd2ff
};

export const WaxChromeRed = {
    id: 'wax-chrome-red',
    name: 'Red Refractor',
    color: '#ff2200',
};

export const WaxChromeGreen = {
    id: 'wax-chrome-green',
    name: 'Green Refractor',
    color: '#00FF4D',
};

export const WaxChromeGold = {
    id: 'wax-chrome-yellow',
    name: 'Gold Refractor',
    color: '#ffd700',
};

export const WaxChromePurple = {
    id: 'wax-chrome-purple',
    name: 'Purple Refractor',
    color: '#8800FF',
};

export const WaxChromeOrange = {
    id: 'wax-chrome-orange',
    name: 'Orange Refractor',
    color: '#FF7B00',
};

export const WaxChromeRoseGold = {
    id: 'wax-chrome-rose-gold',
    name: 'Rose Gold Refractor',
    color: '#9B2F2E',
};

export const WaxChromeSuperFractor = {
    id: 'wax-chrome-super-fractor',
    name: 'Super Fractor',
    colors: ['#ffd700', '#E07800', '#FFD700'],
};

export const WaxChromeColors = {
    white: WaxChromeWhite,
    blue: WaxChromeBlue,
    red: WaxChromeRed,
    green: WaxChromeGreen,
    gold: WaxChromeGold,
    purple: WaxChromePurple,
    orange: WaxChromeOrange,
    roseGold: WaxChromeRoseGold,
};
